import React from 'react'
import Image from 'next/image'

import { severalSideTextEscapeString } from '@constant/index'
import { getImageUrl } from '@lib/simpleFn'
import { PassageCompProps } from '@components/Passages/index'

export default function Passage(passage: PassageCompProps) {
  const passageElementsContainer = []
  if (passage.image) {
    passageElementsContainer.push(
      <div className={'text-center'}>
        <Image
          className={'m-auto'}
          alt="지문 이미지"
          src={getImageUrl(passage.image)}
          width="320"
          height="225"
          unoptimized
        ></Image>
      </div>
    )
  }
  if (passage.text) {
    const createMarkup = () => {
      return { __html: `${passage.text}` }
    }
    if (passage.text.includes(severalSideTextEscapeString)) {
      const texts = passage.text.split(severalSideTextEscapeString)
      const widthValue = Math.floor(100 / texts.length)
      passageElementsContainer.push(
        <div className={'flex w-full'}>
          {texts.map((text) => {
            return (
              <pre
                key={text}
                className={`flex-1 whitespace-pre-wrap break-all text-left w-[calc(${widthValue}-10px) ml-[10px] first:ml-[0px]`}
              >
                {'  ' + text}
              </pre>
            )
          })}
        </div>
      )
    } else {
      passageElementsContainer.push(
        <div>
          <pre
            className={'whitespace-pre-wrap break-all'}
            dangerouslySetInnerHTML={createMarkup()}
          ></pre>
        </div>
      )
    }
  }
  return <>{passageElementsContainer}</>
}
